import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CerebroTextButton } from '../../shared/components';
import { useApi } from '../../shared/context';
import { QueryKeys } from '../../shared/hooks';
import { DataRoomCall } from '../../shared/models';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { getResponseData } from '../../shared/utils/axios';

interface ResetCallDialogProps {
	dataRoomGuid: string | undefined;
	call: DataRoomCall | null;
	close: () => void;
}

export const ResetCallDialog: React.FC<ResetCallDialogProps> = ({ dataRoomGuid, call, close }) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onConfirmation = () => {
		if (call !== null) confirmRequest(call);
	};

	const { mutate: confirmRequest } = useMutation<void, unknown, DataRoomCall>(
		request => getResponseData(api.post(CerebroApiEndpoints.Calls.Reset(dataRoomGuid, request.guid))),
		{
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.Calls.Root(dataRoomGuid));
				snackbar.enqueueSnackbar('Call status successfully reset.', { variant: 'success' });
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem resetting the schedule.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={call !== null} onClose={close}>
			<DialogTitle>Reset Call</DialogTitle>
			<DialogContent>
				<DialogContentText>Are you sure you want to reset this call?</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
